export default {
  SET_RECIPIENT_DETAIL_LIST: 'recipientMasterGetRecipientDetailList',
  SET_RECIPIENT_DETAIL: 'setRecipientDetail',
  SET_SEARCH: 'setSearch',
  SET_RECIPIENT_DETAIL_ALL: 'setRecipientDetailAll',
  SET_RECIPIENT_DETAIL_STATUS: 'setRecipientDetailStatus',
}
